import numeral from "numeral";

const formatRating = (rate: number) => numeral(rate).format("0.[0]");

export default formatRating;
